import script from "./assistant-setting-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./assistant-setting-dialog.vue?vue&type=script&setup=true&lang=js"

import "./assistant-setting-dialog.vue?vue&type=style&index=0&id=2658ce24&lang=scss"

const __exports__ = script;

export default __exports__